import type { GovChipProps } from '@gov-design-system-ce/react';
import type {
	NahledyudajuPppAdresaDto,
	NahledyudajuPppPppStavEnum,
} from '@gov-nx/api';

export const resolveChipColor = (
	status: NahledyudajuPppPppStavEnum | undefined
): { color?: GovChipProps['color'] } => {
	switch (status) {
		case 'PRIJATO':
			return { color: 'neutral' };
		case 'SCHVALENO':
			return { color: 'success' };
		case 'ODESLANO_K_DOPRACOVANI':
		case 'ODESLANO_SPRAVCI':
			return { color: 'warning' };
		case 'ZAMITNUTO':
		case 'UKONCENO':
			return { color: 'error' };

		default:
			return { color: undefined };
	}
};

export const formatAddress = (address?: NahledyudajuPppAdresaDto): string => {
	if (!address) return '';
	const { ulice, cisloPopisne, obec, psc } = address;
	if (!ulice || !cisloPopisne || !obec || !psc) return '';
	return `${ulice} ${cisloPopisne}, ${psc} ${obec}`;
};
